import { parsePhoneNumber } from "libphonenumber-js"

export default function formatPhone(phone: string): string {
  try {
    const parsed = parsePhoneNumber(phone)
    if (parsed) {
      return parsed.countryCallingCode === "1" ? parsed.formatNational() : parsed.formatInternational()
    }
  } catch {
    // Fall through to format unparseable North American numbers.
  }

  const digits = phone.replace(/\D/g, "")
  const national = digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits
  const canUseNorthAmericanFallback = !phone.trim().startsWith("+") || digits.startsWith("1")
  if (canUseNorthAmericanFallback && national.length === 10) {
    return `(${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6)}`
  }

  return phone
}

export function formatPhoneCopyText(phone: string, extension?: string | null): string {
  if (!extension) return phone

  return `${formatPhone(phone)} ext: ${extension}`
}

export function formatPhoneTelHref(phone: string, extension?: string | null): string {
  return `tel:${phone}${extension ? `,,${extension}` : ""}`
}
